import { useState } from 'react'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'
import PlaintiffSearchForm from './PlaintiffSearchForm'
import PlaintiffSearch from './PlaintiffSearch.js'

export default function PlaintiffSelection({ callback, setSelectLargeChoice }) {
  console.log('PlaintiffSelection rendered:')

  const [modal, setModal] = useState(true)
  console.log(modal)
  const [plaintiffSearch, setPlaintiffSearch] = useState(
    <PlaintiffSearchForm 
      largeChoice={true} 
      plaintiffSearchCallback={plaintiffSearchCallback} 
    />)
  const toggle = () => setModal(!modal)

  function exitModal() {
    toggle()
    setSelectLargeChoice(false) // updates state in AppObjectFieldSelect so the modal can get redrawn
  }

  function plaintiffSearchCallback(url) {
    console.log('here')
    url = url.split('?') //url in this format fwinvoice.plaintiff_selection?inputs=${JSON.stringify(inputs)}
    const location = {pathname: `/custom/${url[0]}`, search: `?${url[1]}`}
    setPlaintiffSearch(<PlaintiffSearch 
      location={location} 
      largeChoice={true} 
      largeChoiceCallback={callback} 
      plaintiffSearchCallback={plaintiffSearchCallback}
    />)
  }

  return (
    <Modal isOpen={modal} onClosed={exitModal} backdrop='static' style={{ maxWidth: '90%'}}>
      <ModalHeader toggle={toggle}>Plaintiff Search</ModalHeader>
      <ModalBody style={{ textAlign: 'left', display: 'inline-block', maxWidth: 'none'}}>{plaintiffSearch}</ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={exitModal}>Ok</Button>
      </ModalFooter>
    </Modal>
  )
}
